var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"card",on:{"click":function($event){return _vm.openModal(_vm.card.id)}}},[_c('div',[_vm._v(_vm._s(_vm.title))]),_vm._v(" "),_c('Modal',{attrs:{"id":_vm.card.id},on:{"closedModal":_vm.closedModal}})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2900a8f2","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Card.vue
// module id = 370
// module chunks = 0